// export const dynamic = 'force-dynamic'
import React from 'react'
import urls from '@/utils/urls/urls'
import cl from '@/utils/console/cl'

const BannerFeatureCards = async () => {
    const res = await fetch(urls?.why_choose_us)
    const data = await res.json()
    // const features = data?.data;
    const features = Array.isArray(data?.data) ? data?.data : [];
    // cl("why_choose_us", features)
    // console.log("why_choose_us", features)

    const features1 = features?.slice(0, 3);

    return (
        <>
            <div className="feature-area fa-negative "
            >
                <div className="container">
                    <div className="feature-wrap">
                        <div className="row g-4">
                            {
                                features1?.map((feature: any, index: number) => (
                                    <div className="col-md-6 col-lg-4" key={feature.id}>
                                        <div className="feature-item">
                                            <span className="count">{(index + 1).toString().padStart(2, '0')}</span>
                                            <div className="feature-icon">
                                                {/* <img src="../assets/img/icon/staff.svg" alt="" /> */}
                                                <i className={`${feature.icon_class} icon-size-lg why-choose-us-icon`}></i>
                                            </div>
                                            <div className="feature-content">
                                                <h4>{feature.title}</h4>
                                                <p>
                                                    {feature.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            {/* <div className="col-md-6 col-lg-4">
                                <div className="feature-item">
                                    <span className="count">01</span>
                                    <div className="feature-icon">
                                        <img src="../assets/img/icon/staff.svg" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Experts Staff</h4>
                                        <p>
                                            It is a long established fact that a reader will be distract
                                            by the page readable content when are the looking at its
                                            using layout.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="feature-item">
                                    <span className="count">02</span>
                                    <div className="feature-icon">
                                        <img src="../assets/img/icon/money.svg" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>Affordable Pricing</h4>
                                        <p>
                                            It is a long established fact that a reader will be distract
                                            by the page readable content when are the looking at its
                                            using layout.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4">
                                <div className="feature-item">
                                    <span className="count">03</span>
                                    <div className="feature-icon">
                                        <img src="../assets/img/icon/support.svg" alt="" />
                                    </div>
                                    <div className="feature-content">
                                        <h4>24/7 Support</h4>
                                        <p>
                                            It is a long established fact that a reader will be distract
                                            by the page readable content when are the looking at its
                                            using layout.
                                        </p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BannerFeatureCards
